export enum ID {
  externalService = 'externalService'
}

export const UNUSED_EXTERNAL_SERVICE_ID = 'not_used'
